module.exports = __webpack_public_path__ + "static/media/mr.e12cbc42.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/mr.svg
// module id = 196
// module chunks = 0